import { Link } from 'react-router-dom';

const footerSections = [
  {
    title: '快速导航',
    links: [
      { name: '首页', path: '/' },
      { name: '漫画分类', path: '/category' },
      { name: '排行榜', path: '/category?sort=popular' },
      { name: '最新更新', path: '/category?sort=latest' },
    ],
  },
  {
    title: '热门分类',
    links: [
      { name: '热血漫画', path: '/category/rexue' },
      { name: '恋爱漫画', path: '/category/lianai' },
      { name: '搞笑漫画', path: '/category/gaoxiao' },
      { name: '悬疑漫画', path: '/category/xuanyi' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { name: '品牌介绍', path: '/about#brand' },
      { name: '用户口碑', path: '/about#reputation' },
      { name: '联系我们', path: '/about#contact' },
      { name: '隐私政策', path: '/about#privacy' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-500 text-background-50 dark:text-foreground-950">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="py-12 md:py-16 grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="inline-block cursor-pointer">
              <span className="font-xiaowei text-2xl">布丁漫画</span>
            </Link>
            <p className="mt-3 text-sm text-background-50/70 dark:text-foreground-950/70 leading-relaxed">
              布丁漫画网致力于为漫画爱好者提供最优质的在线阅读体验。海量漫画资源，无删减内容，流畅加载，让您尽情享受漫画世界的精彩。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/20 hover:bg-background-50/30 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line" />
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/20 hover:bg-background-50/30 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line" />
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/20 hover:bg-background-50/30 transition-colors cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line" />
              </a>
            </div>
          </div>

          {footerSections.map((section) => (
            <div key={section.title}>
              <h4 className="font-heading text-base mb-4">
                {section.title}
              </h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-50/70 dark:text-foreground-950/70 hover:text-background-50 dark:hover:text-foreground-950 transition-colors cursor-pointer"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-50/20 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/60 dark:text-foreground-950/60">
            &copy; 2026 布丁漫画网 BudingManhua.com 版权所有
          </p>
          <p className="text-xs text-background-50/60 dark:text-foreground-950/60">
            <span>京ICP备2026000001号</span>
            <span className="mx-2">|</span>
            <span>网络文化经营许可证</span>
          </p>
        </div>
      </div>
    </footer>
  );
}